/**
 * Base API URL
 */
export const BASE_URL = import.meta.env.VITE_APP_API_URL ?? 'http://localhost:3000'

/**
 * Application location variable
 */
export const ENV = import.meta.env.VITE_APP_ENV ?? 'development'
